import {
	SEND_INVITATIONS_SUCCESS,
	SEND_INVITATIONS_ERROR,
	SEND_INVITATIONS,
	SEND_INVITATIONS_ERROR_SHOW,
} from './../../constants';

export const sendInvitationsReducer = (state, actions) => {
	switch (actions.type) {
		case SEND_INVITATIONS:
			return {
				...state,
				loading: true,
			};
		case SEND_INVITATIONS_ERROR:
			return {
				invitations: state.invitations,
				//	collaboratorsOptions: state.collaboratorsOptions,
				loading: false,
				error: actions.payload,
				errorShow: false,
			};
		case SEND_INVITATIONS_SUCCESS:
			return {
				invitations: actions.payload,
				//collaboratorsOptions: getCollaboratorOptions(actions.payload),
				loading: false,
				error: null,
				errorShow: false,
			};
		case SEND_INVITATIONS_ERROR_SHOW:
			return {
				...state,
				errorShow: true,
			};
		default:
			return state;
	}
};
